import { useTranslation } from 'react-i18next';
import DataflowIcon from 'components/atoms/icons/dataflow';
import classNames from 'classnames';
import BaseRadioButton from 'components/atoms/baseRadioButton';
import InfoIcon from 'components/atoms/icons/infoIcon';
import ClinicReviewTimeControlButton from 'components/molecules/control-buttons/clinic-review-time';

import s from '../styles.module.scss';
import InfoTooltip from '../tooltip';

interface IProps {
  childCount: number;
  name: string;
  reviewTimeSeconds: number;
  onReviewTimeChange: (reviewTimeSeconds: number) => void;
  updateChildrenReviewTime: boolean;
  setUpdateChildrenReviewTime: (updateChildrenReviewTime: boolean) => void;
}

const ClinicReviewTimeModalMenuBody = ({
  childCount,
  name,
  reviewTimeSeconds,
  onReviewTimeChange,
  updateChildrenReviewTime,
  setUpdateChildrenReviewTime,
}: IProps) => {
  const { t } = useTranslation();

  const handleChangeValue = (val: boolean) => {
    setUpdateChildrenReviewTime(val);
  };

  const noChild = !childCount;

  return (
    <div className={s.content}>
      <ClinicReviewTimeControlButton
        value={reviewTimeSeconds}
        onChange={onReviewTimeChange}
      />
      <div className={s.block}>
        <div className={s.top} onClick={() => handleChangeValue(false)}>
          <BaseRadioButton
            id="applyToParentClinicOnly"
            name="applyToParentClinicOnly"
            value="false"
            onChange={() => handleChangeValue(false)}
            checked={updateChildrenReviewTime === false}
          />
          {t('labels.applyOnlyToCurrentClinic')}
          <InfoTooltip message={t('messages.currentOnlyUpdate')}>
            <InfoIcon />
          </InfoTooltip>
        </div>
        <div className={s.bottom}>{name}</div>
      </div>
      <div className={classNames(s.block, noChild && s.disabled)}>
        <div className={s.top} onClick={() => handleChangeValue(true)}>
          <BaseRadioButton
            id="applyToAllChildClinics"
            name="applyToAllChildClinics"
            onChange={() => handleChangeValue(true)}
            value="true"
            checked={updateChildrenReviewTime === true}
          />
          {noChild
            ? t('labels.noChildClinicsToUpdate')
            : t('labels.applyToCurrentAndChildClinics')}

          {!noChild && (
            <InfoTooltip message={t('messages.applyToAllUpdate')}>
              <InfoIcon />
            </InfoTooltip>
          )}
        </div>
        {!noChild && (
          <div className={classNames(s.bottom, s.child)}>
            {t('labels.willUpdate')}
            <span>
              <DataflowIcon />
              {childCount}
            </span>
            {t('labels.childClinics')}
          </div>
        )}
      </div>
      <div className={s['description-message']}>
        {t('messages.updateInBackgroundDescription')}
      </div>
    </div>
  );
};

export default ClinicReviewTimeModalMenuBody;
